var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.inputsExtraCadastro.georreferencia.texto
        ? _c(
            "el-alert",
            {
              staticClass: "margin-bottom",
              attrs: { title: "Atenção", type: "info" }
            },
            [
              _c("span", [
                _vm._v("O Georreferenciamento deve ser da área atual")
              ])
            ]
          )
        : _vm._e(),
      !_vm.georreferenciamentoSigef
        ? _c(
            "div",
            [
              _c("div", { staticClass: "mapa" }),
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Georreferenciamento/Geometria"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("mapa", {
                            attrs: {
                              localizacoes: _vm.localizacoes,
                              name: "Geometria",
                              idMapa: "mapaCadastroGeo",
                              errors: errors
                            },
                            model: {
                              value: _vm.localizacoes,
                              callback: function($$v) {
                                _vm.localizacoes = $$v
                              },
                              expression: "localizacoes"
                            }
                          }),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2028670959
                )
              }),
              _c(
                "div",
                [
                  _c("app-documentos", {
                    attrs: {
                      maxSize: 25000,
                      "valid-extensions": ["rar", "zip"],
                      documentos: _vm.cadastro.georreferenciamento.documentos,
                      tiposDocumentos: _vm.documentos,
                      tiposDocumentosObrigatorios: _vm.docsNotRequired
                        ? []
                        : _vm.documentos,
                      observer: _vm.observer,
                      pecasTecnicas: true,
                      aba: "Georreferenciamento"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            _vm.showGeorreferenciamentoOption
              ? _c(
                  "div",
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: "required",
                        name: "Georreferenciamento/Possui Georreferenciamento'"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label:
                                      "Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?"
                                  }
                                }),
                                _c(
                                  "el-radio-group",
                                  {
                                    staticClass: "radio-group margin-bottom",
                                    attrs: {
                                      "data-vv-scope": "georreferenciamento",
                                      "data-vv-validate-on": "change",
                                      "data-vv-delay": "10",
                                      name: "possuiGeorrefenrenciamento"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastro.georreferenciamento
                                          .possuiGeorreferenciamento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastro.georreferenciamento,
                                          "possuiGeorreferenciamento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastro.georreferenciamento.possuiGeorreferenciamento"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "POSSUI" } },
                                      [_vm._v("Sim")]
                                    ),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "NAO_POSSUI" } },
                                      [_vm._v("Não")]
                                    )
                                  ],
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1728556565
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.cadastro.georreferenciamento.possuiGeorreferenciamento ===
            "NAO_POSSUI"
              ? _c(
                  "div",
                  { staticClass: "mapa" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: "required",
                        name: "Georreferenciamento/Geometria"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("mapa", {
                                  attrs: {
                                    localizacoes: _vm.localizacoes,
                                    name: "Geometria",
                                    idMapa: "mapaCadastroGeo",
                                    errors: errors
                                  },
                                  model: {
                                    value: _vm.localizacoes,
                                    callback: function($$v) {
                                      _vm.localizacoes = $$v
                                    },
                                    expression: "localizacoes"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2028670959
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.cadastro.georreferenciamento.possuiGeorreferenciamento ===
            "POSSUI"
              ? _c(
                  "div",
                  [
                    _c("app-dados-responsavel", {
                      attrs: {
                        responsavel:
                          _vm.cadastro.georreferenciamento.responsavel,
                        nomeAba: "Georreferenciamento"
                      }
                    }),
                    _c("app-documentos", {
                      attrs: {
                        maxSize: 25000,
                        "valid-extensions": _vm.extensoes,
                        documentos: _vm.cadastro.georreferenciamento.documentos,
                        tiposDocumentos: _vm.documentos,
                        tiposDocumentosObrigatorios: _vm.docsNotRequired
                          ? []
                          : _vm.documentos,
                        observer: _vm.observer,
                        pecasTecnicas: true,
                        aba: "Georreferenciamento"
                      },
                      on: {
                        mudaTipo: _vm.mudaTipo,
                        setDadosPlanilha: _vm.setDadosPlanilha
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b94b095", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b94b095","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppGeorreferenciamento.vue
// module id = null
// module chunks = 